const prodVuoto = {
    codiceVS: "NO DATA",
    codicePS: "",
    brand: "",          // utile da avere per interpretare il codice produttore e per predisporre ai precaricamenti automatici da tracciato
    codiceProduttore: {
        codProduttoreIntero: "",
        codProduttoreModello: "",
        codProduttoreColore: "",
        codProduttoreCollezione: "",
        codProdSci: {
            codProduttorePiastra: "",
            codProduttoreAttacchi: "",
            codProduttoreKit: ""
        }
    },
    persona: {
        age: "", //baby, junior, senior, neutra, nonDefinibile
        sex: "", //man, woman, unisex, neutra, nonDefinibile
    },
    url_pagina_uff: "",
    shortName: {
        it: "",
        en: "",
        fr: "",
        de: "",
        es: ""
    },
    titolo: {
        tipoProdotto: "", // rimanda all'id del tipo di prodotto, in modo da poter aggiornare le corrispondenze nelle traduzioni e aggiungere in blocco nuove lingue
        nomeProdotto: "",
        componentiSci: {
            piastra: "",
            attacchi: "",
            pelli: ""
        },
        dettagliAggiuntivi: {
            attivita: "",       // Running, Scialpinismo, Lifestyle ecc
            attributo: "",    // Gore-Tex®, Waterproof, Original® ecc
            stagione: ""                    // - 2021 | 2022
        }
    },
    descrizioneID: "", // rimanda a id descrizione, che voglio fare come il primo codice prodotto per cui la creo con un D all'inizio (???)
    lavorazioni: [""], // TIPO / UTENTE / APPUNTI (fare nuovo schema, gestire autenticazione) capire come fare, dovrebbe essere una array a cui viene pushata ogni volta un dato con tipo di lavorazione, data e appunti, in modo da fare una cronologia percorribile di appunti e controlli
    datiUlterioriProdottoSingolo: {
        // VANNO A SOVRASCRIVERE I DATI ULTERIORI DEL MODELLO SE PRESENTI - racchiuderebbe tutti i dati ulteriori delle schede di 2bit, capire se predisporre o no. bisogna vedere cosa può essere tipico del modello in generale e cosa del prodotto singolo (ad. es capienza zaini ecc)
        colore: {
            denominazione: "",
            colore1: 0, //id di uno dei 24 colori standard del sito, selezionato nel programma direttamente tramite anteprima hex
            colore2: 0, //id di uno dei 24 colori standard del sito, selezionato nel programma direttamente tramite anteprima hex
            colore3: 0  //id di uno dei 24 colori standard del sito, selezionato nel programma direttamente tramite anteprima hex
        },
        dimensioni: "",
        capienza: "", // vedere come fare, per indicizzare ad es. gli zaini in base al litraggio servirebbe un Number, ma se mettiamo i 30+5 diventa una stringa. Accettare stringhe e poi fare le operazioni

    },
    descrizioniSuPS: {
        titolo: {
            it: "",
            en: "",
            fr: "",
            de: "",
            es: ""
        },
        descBreve: {
            it: "",
            en: "",
            fr: "",
            de: "",
            es: ""
        },
        descLunga: {
            it: "",
            en: "",
            fr: "",
            de: "",
            es: ""
        },
        descIntro: {
            it: "",
            en: "",
            fr: "",
            de: "",
            es: ""
        }
    },
    // vedere come gestire le taglie per le conversioni taglie, e in seguito se fare in modo di accogliere gli ean di tutte le varianti con un tracciato da precaricamento
    tradotto: {
        en: false,
        fr: false,
        de: false,
        es: false
    },
    strutturato: false,
    tradottoStrutturato: false,
    esportato: false,
    dataUltimaEsportazione: false

};

export default prodVuoto;
